import React from 'react'

const CardDivider = () => {
  return (
    <div className={'cardDivider'} />
  )
}

export default CardDivider